// extracted by mini-css-extract-plugin
export default {"buttonGroupContainer":"PortalCommunicationRevokeAllPopup_buttonGroupContainer__hQYY6"};